if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        // ✅ Cacher toutes les images au lieu de seulement enlever `.active`
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('active');
          element.style.display = 'none'; // Cacher toutes les images
        });

        // ✅ Trouver l'image sélectionnée et l'afficher seule
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );

        if (activeMedia) {
          activeMedia.classList.add('active');
          activeMedia.style.display = 'block'; // Afficher seulement l'image sélectionnée
          activeMedia.scrollIntoView();

          // ✅ Centrer l'image sélectionnée
          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.clientWidth - container.clientWidth) / 2;

          // ✅ Si c'est une vidéo YouTube, la charger immédiatement
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

          if (
            activeMedia.nodeName === 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }
        }
      }
    }
  );
}
